module.exports = __webpack_public_path__ + "img/top_bg.fc945a78.jpg";